import { GoogleTagManager } from '@next/third-parties/google'
import googleTagManagerClient from '@utils/analytics/gtm'
import React from 'react'

import { OrganizationIntegrationType, OrgInt } from 'types/model/orgInt'

export default function GTM({ integrations }: { integrations: OrgInt[] }) {
  const [initialized, setInitialized] = React.useState(false)

  React.useEffect(() => {
    if (!initialized) {
      setInitialized(true)

      googleTagManagerClient.install()
    }
  }, [])

  const gtmId = integrations.find(
    (integration) => integration.type === OrganizationIntegrationType.GOOGLE_TAG_MANAGER
  )?.googleTagManager?.containerId

  if (gtmId) {
    return <GoogleTagManager gtmId={gtmId} />
  }

  return null
}
